<template>
  <div class="login-dialog">
    <div class="header-section">
      <div class="title">欢迎登录</div>
      <div class="subtitle">山东省护理学会e护考培平台</div>
    </div>
    <div class="content">
      <div class="telephone">
        <span>手机号</span>
        <el-input
          v-model="telephone"
          placeholder="请输入手机号"
          maxlength="11"
          size="medium"
        ></el-input>
      </div>
      <div class="password">
        <span>密码</span>
        <el-input
          v-model="password"
          show-password
          placeholder="请输入密码"
          size="medium"
        ></el-input>
      </div>
      <div class="login-tips">
        登录即代表同意<el-link
          href="/#/userProtocol"
          class="privacy-link"
          target="_blank"
          type="primary"
          >《用户协议》</el-link
        >及<el-link
          href="/#/privacy"
          class="privacy-link"
          target="_blank"
          type="primary"
          >《隐私政策》</el-link
        >
      </div>
      <div
        class="login-btn"
        :class="{ 'disabled-btn': submitting }"
        @click="login"
        v-loading="submitting"
      >
        登录
      </div>
      <div class="more-link">
        <div class="forget-password" @click="showForgetPage">忘记密码</div>
        <div class="reg" @click="showRegPage">注册</div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      telephone: "",
      password: "",
      submitting: false
    };
  },
  methods: {
    async login() {
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      if (this.telephone.length !== 11 || this.password.length === 0) {
        this.submitting = false;
        this.$message.error("请输入正确的手机号或密码！");
        return;
      } else {
        this.submitting = true;
        const params = {
          phone: this.telephone,
          password: this.password,
          lastLoginTerminal: 0
        };
        let res = await httpRequest("/app/user/token", "get", params);
        if (res !== null && res !== undefined && res.code === 200) {
          this.$message.success("登录成功");
          localStorage.setItem("pc_user_token", res.data);
          // 继续获取用户信息
          res = await httpRequest("/app/user", "get", null);
          if (res !== null && res !== undefined && res.code === 200) {
            localStorage.setItem("pc_user", JSON.stringify(res.data));
          }
          // 跳转到首页
          this.$router.push({ path: "/" });
        }
        this.submitting = false;
      }
    },
    showForgetPage() {
      this.$router.push({ path: "/forget" });
    },
    showRegPage() {
      this.$router.push({ path: "/reg" });
    }
  }
};
</script>

<style scoped lang="scss">
.login-dialog {
  width: 500px;
  background: #ffffff;
  margin: 100px auto;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  
  .header-section {
    text-align: center;
    margin-bottom: 40px;
    
    .title {
      font-size: 28px;
      font-weight: 500;
      color: #035DB3;
      margin-bottom: 10px;
    }
    
    .subtitle {
      font-size: 16px;
      color: #035DB3;
      font-weight: 400;
    }
  }

  .content {
    .telephone, .password {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      
      span {
        width: 60px;
        text-align: right;
        margin-right: 15px;
        font-size: 16px;
        color: #333;
      }
      
      .el-input {
        flex: 1;
      }
    }

    .login-tips {
      font-size: 14px;
      color: #666;
      text-align: center;
      margin-top: 10px;
      
      .privacy-link {
        font-size: 14px;
        vertical-align: baseline;
      }
    }

    .login-btn {
      height: 45px;
      line-height: 45px;
      background: #035DB3;
      border-radius: 10px;
      margin-top: 30px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
      text-align: center;
      transition: opacity 0.3s;
      
      &:hover {
        opacity: 0.9;
      }
    }

    .disabled-btn {
      cursor: not-allowed !important;
      opacity: 0.7;
    }

    .more-link {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
      padding: 0 10px;
      
      div {
        font-size: 14px;
        color: #666;
        cursor: pointer;
        
        &:hover {
          color: #035DB3;
        }
      }
    }
  }
}
</style>
